var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrvtoTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2884 18.2817L15.5751 14H12.4134L7.70006 18.2817C6.38172 19.4717 5.95006 21.3033 6.59172 22.96C7.23339 24.605 8.79672 25.6667 10.5584 25.6667H17.4301C19.2034 25.6667 20.7551 24.605 21.3967 22.96C22.0384 21.3033 21.6067 19.4717 20.2884 18.2817ZM16.1234 21.1633H11.8767C11.4334 21.1633 11.0834 20.8017 11.0834 20.37C11.0834 19.9383 11.4451 19.5767 11.8767 19.5767H16.1234C16.5667 19.5767 16.9167 19.9383 16.9167 20.37C16.9167 20.8017 16.5551 21.1633 16.1234 21.1633Z",
    fill: "#007AFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4084 5.04016C20.7668 3.39516 19.2034 2.3335 17.4418 2.3335H10.5584C8.79677 2.3335 7.23344 3.39516 6.59177 5.04016C5.96177 6.69683 6.39344 8.5285 7.71177 9.7185L12.4251 14.0002H15.5868L20.3001 9.7185C21.6068 8.5285 22.0384 6.69683 21.4084 5.04016ZM16.1234 8.43516H11.8768C11.4334 8.43516 11.0834 8.0735 11.0834 7.64183C11.0834 7.21016 11.4451 6.8485 11.8768 6.8485H16.1234C16.5668 6.8485 16.9168 7.21016 16.9168 7.64183C16.9168 8.0735 16.5551 8.43516 16.1234 8.43516Z",
    fill: "#007AFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrvtoTimer);
export default __webpack_public_path__ + "static/media/trvto_timer.cd5420435a7a236d3529ef710c47c019.svg";
export { ForwardRef as ReactComponent };